import { Flex, Text } from "@chakra-ui/react";
import { Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import { BOX_SHADOW } from "../const";
import { capitalizeWordsNoUnderscore } from "../utils";
import { ContentWidthContainer } from "./ContentWidthContainer";
import { useAreasModalStore } from "../stores/AreasModalStore";

export const AreaNavigationBar: React.FC = () => {
  const { pathname } = useLocation();

  const segments = pathname.split("/");
  // This line is responsible for creating links
  // Given a pathname of '/hello/this/is/flume' it will output [ '/hello/this', '/hello/this/is', '/hello/this/is/flume' ]
  const links = segments.slice(2).map((_, index) => `/${segments.slice(1, index + 3).join("/")}`);

  const shouldAppendDividerToAreas = links.length > 0;
  const { onOpen } = useAreasModalStore(["onOpen"]);

  return (
    <Flex w="100%" bg="white" borderTop="1px" borderColor="gray.300" boxShadow={BOX_SHADOW}>
      <ContentWidthContainer>
        <Text as="span" cursor="pointer" onClick={onOpen}>
          Areas {shouldAppendDividerToAreas ? "/" : ""}
        </Text>
        {links.map((link, i) => {
          const text = capitalizeWordsNoUnderscore(segments[i + 2]);
          const shouldAppendDivider = i + 3 < segments.length;
          return (
            <Fragment key={i}>
              <Link to={link} key={i} style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                {text}
              </Link>
              {shouldAppendDivider && <span>/</span>}
            </Fragment>
          );
        })}
      </ContentWidthContainer>
    </Flex>
  );
};
